import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button, Select, MenuItem} from '@material-ui/core';
import {TextField, Checkbox, FormControlLabel} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import DialogAuthorization from '../components/DialogAuthorization';
import TagsOptions from '../components/TagsOptions';
import QuestionViewInc from './QuestionViewInc';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const childRefAuthorization = React.useRef();
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [dataLoading, setDataLoading] = React.useState(false);
  const [question, setQuestion] = React.useState("");

  const [gradeList, setGradeList] = React.useState([]);
  const [difficultyList, setDifficultyList] = React.useState([]);
  const [languageList, setLanguageList] = React.useState([]);
  const [countryList, setCountryList] = React.useState([]);
  const [tagsList, setTagsList] = React.useState([]);
  const [keywordsList, setKeywordsList] = React.useState([]);
  
  const [tags, setTags] = React.useState([]);
  const [keywordNames, setKeywordNames] = React.useState([]);  

  const [gradeId, setGradeId] = React.useState(0);
  const [gradeName, setGradeName] = React.useState('');
  const [difficultyId, setDifficultyId] = React.useState(0);
  const [difficultyName, setDifficultyName] = React.useState('');
  const [language, setLanguage] = React.useState('English');
  const [country, setCountry] = React.useState('India');
  const [checkedSH, setCheckedSH] = React.useState(false);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {	
    setCheckedSH(false);
		if(open && props?.dataObj && props?.dataObj?.autoId>0 && userObj.loginId && userObj.token){	
			setQuestion(props?.dataObj?.questionJson);
      setGradeId(props?.dataObj?.gradeId);
      setGradeName(props?.dataObj?.gradeName);
      setDifficultyId(props?.dataObj?.difficultyId);
      setDifficultyName(props?.dataObj?.difficultyName);
      setLanguage(props?.dataObj?.language?props?.dataObj?.language:'English');
      setCountry(props?.dataObj?.country?props?.dataObj?.country:'India');

      if(props.dataObj.tags && props.dataObj.tags.length>0){
        setTags(props.dataObj.tags.split(","));
      }else{
        setTags([]);
      }

      if(props.dataObj.keywordNames && props.dataObj.keywordNames?.length>0){
        setKeywordNames(props.dataObj.keywordNames.split(","));
      }else{
        setKeywordNames([]);
      }

      getApiData();
		}
	}, [props.dataObj,open]);

	async function getApiData(){
		if(userObj.loginId && userObj.token){
			setDataLoading(true);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 

			axios.get(env.API_URL+"/exams/read/question-mixmetadata", axiosHeader) 
			   .then(response => {
				//document.write(JSON.stringify(response));
				 setDataLoading(false);
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					childRefAuthorization.current.handleClickOpen();
				}else if(response.data && response.data.responseTxt==="success"){
					setGradeList(response?.data?.obj?.gradeList);
					setDifficultyList(response?.data?.obj?.difficultyList);
          setLanguageList(response?.data?.obj?.languageList);
					setCountryList(response?.data?.obj?.countryList);
          if(response?.data?.obj?.tagsList.length>0){
            setTagsList(response?.data?.obj?.tagsList);
          }else{
            setTagsList([{title:'Tag One'}]);
          }
          if(response?.data?.obj?.keywordsList.length>0){
            setKeywordsList(response?.data?.obj?.keywordsList);
          }else{
            setKeywordsList([{title:'Keyword One'}]);
          }

          
				}		
			})
			.catch((error) => {
				alert("ERROR: ", error);
			})	
		}	
	}


	function saveData(){    
    
    if(!question || (question && question.length<1)){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter question");			
      return false;
    }  
    
		if(question && question.length>1){ 
      setSaveLoading(true);

			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/form-data',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'	
				}
			}; 

			const data = new FormData();
      data.append('id', props?.dataObj?.autoId);
      data.append('payload', question);

      if(gradeId && gradeId>0 && gradeName && gradeName.length>0){
        data.append('gradeId', gradeId);
        data.append('gradeName', gradeName);
      }else{
        data.append('gradeId', 0);
        data.append('gradeName', '');
      }
      if(difficultyId && difficultyId>0 && difficultyName && difficultyName.length>0){
        data.append('difficultyId', difficultyId);
        data.append('difficultyName', difficultyName);
      }else{
        data.append('difficultyId', 0);
        data.append('difficultyName', '');
      }
      if(language && language.length>0){
        data.append('language', language);
      }else{
        data.append('language', '');
      }
      if(country && country.length>0){
        data.append('country', country);
      }else{
        data.append('country', '');
      }

      if(tags && tags.length>0){
        data.append('tags', tags.join(","));
      }else{
        data.append('tags', '');
      }

      if(keywordNames && keywordNames.length>0){
        data.append('keywordNames', keywordNames.join(","));
      }else{
        data.append('keywordNames', '');
      }

      
      let apiURL='/exams/update/question-bank';
      let myMessage="Questions have been updated.";

      if(props.editCD===true){
        apiURL='/exams/update/question-grouped';
      }

			axios.post(env.API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          
          if(checkedSH===true){
            //Call API to update Student Test History...........
            getApiDataUpdateStudentHistory();
          }

          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          props.reloadFlag(true);          
					return false;
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This question could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	}

  async function getApiDataUpdateStudentHistory(){
		if(userObj.loginId && userObj.token && props.dataObj.displayId && props.dataObj.displayId.length>0 ){
			setDataLoading(true);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed'
				}
			}; 

			axios.get(env.UserPanel_API_URL+"/app/adminx-test-history-update?displayId="+props.dataObj.displayId, axiosHeader) 
			   .then(response => {
				//document.write(JSON.stringify(response));				
				if(response.data && response.data.responseTxt==="success"){
					          
				}		
			})
			.catch((error) => {
				alert("ERROR: ", error);
			})	
		}	
	}


  function handleDifficulty(val){
    let valArr = val.split('#');
    setDifficultyId(valArr[0]);
    setDifficultyName(valArr[1]);
  }

  function handleGrade(val){
    let valArr = val.split('#');
    setGradeId(valArr[0]);
    setGradeName(valArr[1]);
  }
  
  function selectedTags(arr) {
    setTags(arr);
  }

  function selectedKeywordNames(arr) {
    setKeywordNames(arr);
  }

  const handleChangeSH = (event) => {
    setCheckedSH(event.target.checked);
  };
  
  
  return (
    <>
      <Dialog fullWidth maxWidth="lg" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12}>
                  <div className="btmbdrgry"><h4>Edit Question</h4></div>
                  <p>                
                  <Grid container spacing={2}> 
                    <Grid item md={6} xs={12}> 
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                                <TextField onChange={event => setQuestion(event.target.value)} value={question} sx={{width:'100%',fontSize: 10}} variant="outlined" multiline={true} rows={15}  />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                                <Select 
                                        fullWidth
                                        labelId="select-class-label"
                                        id="select-class"
                                        value={gradeId+'#'+gradeName}									
                                        onChange={event => handleGrade(event.target.value)}
                                        variant="standard"
                                      >
                                          <MenuItem value={'0#'} >Select Grade</MenuItem>
                                          {(gradeList && gradeList.length>0)?gradeList.map((row,i)=>(
                                            <MenuItem key={'tchr'+i} value={row.autoId+'#'+row.gradeName}>{row.gradeName}</MenuItem>
                                          )):null}                
                                </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                                <Select 
                                        fullWidth
                                        labelId="select-class-label"
                                        id="select-class"
                                        value={difficultyId+'#'+difficultyName}									
                                        onChange={event => handleDifficulty(event.target.value)}
                                        variant="standard"
                                      >
                                          <MenuItem value={'0#'} >Select Difficulty</MenuItem>
                                          {(difficultyList && difficultyList.length>0)?difficultyList.map((row,i)=>(
                                            <MenuItem key={'tchr'+i} value={row.autoId+'#'+row.difficultyName}>{row.difficultyName}</MenuItem>
                                          )):null}                
                                </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                                <Select 
                                        fullWidth
                                        labelId="select-class-label"
                                        id="select-class"
                                        value={language}									
                                        onChange={event => setLanguage(event.target.value)}
                                        variant="standard"
                                      >
                                          {(languageList && languageList.length>0)?languageList.map((row,i)=>(
                                            <MenuItem key={'tchr'+i} value={row.languageName}>{row.languageName}</MenuItem>
                                          )):null}                
                                </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                                <Select 
                                        fullWidth
                                        labelId="select-class-label"
                                        id="select-class"
                                        value={country}									
                                        onChange={event => setCountry(event.target.value)}
                                        variant="standard"
                                      >
                                          <MenuItem value={''} >Select Country</MenuItem>
                                          {(countryList && countryList.length>0)?countryList.map((row,i)=>(
                                            <MenuItem key={'tchr'+i} value={row.country}>{row.country}</MenuItem>
                                          )):null}                
                                </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                            {(tagsList && tagsList.length>0)?  
                              <div style={{marginTop: 10}}>  
                                  <TagsOptions defaultValues={tags} selectedTags={selectedTags} options={tagsList} label="Tags" placeholder="Type & press enter key" freeSolo={true} />
                              </div>
                            :null}  
                            </td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>                            
                            {(keywordsList && keywordsList.length>0)?
                              <div style={{marginTop: 10}}>
                                  <TagsOptions defaultValues={keywordNames} selectedTags={selectedKeywordNames} options={keywordsList} label="Keywords" placeholder="Select keyword" freeSolo={false} />
                              </div>
                            :null}
                          </td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                              <FormControlLabel 
                              control={<Checkbox checked={checkedSH} onChange={handleChangeSH}  />}
                              label="Student Test History Update" />
                            </td>
                        </tr>      
                      </table>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <QuestionViewInc question={question?JSON.parse(question):null} />
                    </Grid>

                  </Grid>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          {saveLoading?
                          <LoadingButton loadingPosition="start" startIcon={<div style={{marginRight:20}}></div>} loading={saveLoading} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Saving</LoadingButton>
					    	          :
                          <Button onClick={() => {saveData()}} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Save</Button>
                          }
                      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

        <DialogAuthorization ref={childRefAuthorization} />

    </>
  );

});

export default CustomizedDialogs;